import type { Transition } from "@uirouter/react";

export const onRedirectSearchAdsPages = (transition: Transition) => {
    const toParams = transition.params();
    const fromState = transition.from().name;
    const toState = transition.to().name;

    if (toState !== fromState) {
        if (toParams.multiIncludeExcludeUrl) {
            return { params: { ...toParams, multiIncludeExcludeUrl: undefined } };
        }
    }
};
